import { bl_fi_budget_category_attachment_RowClass } from "../../../dbschema/bl_fi_budget_category_attachment.model";
import { BaseContainerModel } from "../../base-container.model";

export class BudgetCategoryAttachmentContainerModel extends BaseContainerModel {
  bl_fi_budget_category_attachment: bl_fi_budget_category_attachment_RowClass =
    new bl_fi_budget_category_attachment_RowClass();
}
